import { render, staticRenderFns } from "./OrganizationDashboard.vue?vue&type=template&id=f7095e10"
import script from "./OrganizationDashboard.vue?vue&type=script&lang=ts"
export * from "./OrganizationDashboard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports